import type { AccountStatus } from "../lib/types";

interface Props {
  status: AccountStatus;
}

const COLOR_MAP: Record<AccountStatus, string> = {
  flagged: "#d9645c",
  warning: "#d9b14a",
  healthy: "#6dbf78",
  idle: "rgba(255,255,255,0.2)",
};

const LABEL_MAP: Record<AccountStatus, string> = {
  flagged: "Flagged",
  warning: "Warning",
  healthy: "Healthy",
  idle: "Idle",
};

export function StatusDot({ status }: Props) {
  const label = LABEL_MAP[status];
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      style={{
        display: "inline-block",
        width: 8,
        height: 8,
        borderRadius: "50%",
        backgroundColor: COLOR_MAP[status],
        verticalAlign: "middle",
        marginRight: 8,
        flexShrink: 0,
      }}
    />
  );
}
